export enum AppLanguage {
  Pl = 'pl',
  En = 'en'
}
